// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__3BF5V","scrollSection":"Page_scrollSection__notnA"};